export const DocumentExportType = Object.freeze({
  receipt: 'notAssigned',
  incomingInvoice: 'incomingInvoice',
  invoice: 'invoice',
  invoiceCorrection: 'invoiceCorrection',
  withdrawal: 'withdrawal',
  deposit: 'deposit',
  contract: 'contract',
  xReport: 'xReport',
  zReport: 'zReport',
  cancellation: 'cancellation',
})
